import { ref } from 'vue'
import { defineStore } from 'pinia'
import { type PrinterStatus } from '#src/interfaces/PrinterStatus'

const useDeviceManagementPrinterStatusStore = defineStore(
  'deviceManagementPrinterStatusStore',
  () => {
    const printerStatus = ref<PrinterStatus>({
      valid: false,
      code: 'undefined',
      message: '',
      paperLow: false,
      paperOut: false
    })

    const setPrinterStatus = (status: PrinterStatus) => {
      printerStatus.value = status
    }

    const isPrinterValid = () => printerStatus.value.valid

    const isStatusPaperLow = () => printerStatus.value.paperLow

    const isStatusPaperOut = () => printerStatus.value.paperOut

    const isStatusOffline = () => !isPrinterValid()

    return {
      printerStatus,
      setPrinterStatus,
      isPrinterValid,
      isStatusPaperLow,
      isStatusPaperOut,
      isStatusOffline
    }
  }
)

export { useDeviceManagementPrinterStatusStore }
